import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconVoices = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.1121 7.47209C13.689 4.19765 10.8902 1.66797 7.50065 1.66797C3.81875 1.66797 0.833984 4.65274 0.833984 8.33464C0.833984 9.91164 1.38154 11.3607 2.2969 12.5022C2.97024 13.3419 3.33426 14.2723 3.33419 15.2564L3.33398 18.3346H10.834L10.8348 15.8346H12.5007C13.4212 15.8346 14.1673 15.0885 14.1673 14.168V11.7271L15.8001 11.0277C16.0861 10.9052 16.111 10.6152 15.9875 10.4211L14.1121 7.47209ZM2.50065 8.33464C2.50065 5.57321 4.73923 3.33464 7.50065 3.33464C10.0209 3.33464 12.1394 5.21081 12.4591 7.68562L12.5067 8.05348L13.7921 10.0747L12.5007 10.6279V14.168H9.16874L9.1679 16.668H5.00076L5.00086 15.2566C5.00095 13.8906 4.50869 12.5963 3.59713 11.4596C2.8908 10.5787 2.50065 9.48872 2.50065 8.33464ZM17.6286 15.0866L16.2417 14.1621C17.037 12.9715 17.5007 11.5406 17.5007 10.0014C17.5007 8.46214 17.037 7.03122 16.2417 5.84065L17.6286 4.91606C18.6007 6.37119 19.1673 8.12009 19.1673 10.0014C19.1673 11.8826 18.6007 13.6315 17.6286 15.0866Z",
		fill: "#0F0140"
	})
});
export default SvgIconVoices;
